export default "__VITE_ASSET__f5745358__"